import { useState } from 'react';
import config from '../../config';
import { authHeader } from '../../Helpers/auth-header';
import { Loading } from '../../Components';
import { toast } from "react-toastify";

export function ConnectionStatusCardComponent({direction}) {
    const [status, setStatus] = useState('Unknown'); 
    const [organizationId, setOrganizationId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    if(!organizationId) {
        setOrganizationId(JSON?.parse(window.sessionStorage.getItem('user'))?.id);
    }

    const testConnection = () => {
        setIsLoading(true);
        fetch(
            `${config.apiUrl}/api/connections/?direction=${direction}`, 
            {method: 'GET', headers: { 'Accept': 'application/json', ...authHeader() }}
        )
        .then((response) => {
            return response.json();
        })
        .then((response) => {
            if(!response?.connection) {
                setStatus('Not configured');
                return;
            }
            let connectionConfig = response.connection.config;
            let body = {
                type: response.connection.type,
                connection: {...connectionConfig}
            };
    
            const testRequestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', ...authHeader() },
                body: JSON.stringify(body)
            };
            return fetch(`${config.apiUrl}/api/connections/test`, testRequestOptions );
        })
        .then((response) => {

            if(!response) {
                return;
            }

            if(response.ok) {
                toast.success('Connected successfully!');
                setStatus('Connected');
            } else {
                toast.warning('Unable to connect.');
                setStatus('Disconnected');
            }
        })
        .catch((error) => {
            console.log('error stack: ', error.stack);
            toast.error(
                `Unknown error.
                Please provide the following information to Arcane Support: ${error.message}`,
                {autoClose: false})
            ;
            setStatus('Unknown Error: ' + error.message);
        })
        .finally(()=>{
            setIsLoading(false);
        })
    }

    let title = direction.charAt(0).toUpperCase() + direction.slice(1) + " Connection Status";
    
    // Determine status card class based on status
    let statusCardClass = 'status-card';
    if (status === 'Connected') {
        statusCardClass += ' success';
    } else if (status === 'Disconnected' || status.includes('Error')) {
        statusCardClass += ' danger';
    } else if (status === 'Not configured') {
        statusCardClass += ' warning';
    } else {
        statusCardClass += ' info';
    }
    
    return (<>
        {isLoading && <Loading/>}
        <div className="col-md-6">
            <div className={statusCardClass}>
                <div className="d-flex align-items-center justify-content-between mb-3">
                    <h5 className="mb-0 fw-semibold">{title}</h5>
                    <div className="status-icon">
                        {status === 'Connected' && <i className="bi bi-check-circle-fill text-success fs-4"></i>}
                        {(status === 'Disconnected' || status.includes('Error')) && <i className="bi bi-x-circle-fill text-danger fs-4"></i>}
                        {status === 'Not configured' && <i className="bi bi-exclamation-triangle-fill text-warning fs-4"></i>}
                        {status === 'Unknown' && <i className="bi bi-question-circle-fill text-muted fs-4"></i>}
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                    <div className="status-info">
                        <span className="text-muted small">Status:</span>
                        <div className={`fw-medium ${status === 'Connected' ? 'text-success' : 
                            (status === 'Disconnected' || status.includes('Error')) ? 'text-danger' : 
                            status === 'Not configured' ? 'text-warning' : 'text-muted'}`}>
                            {status}
                        </div>
                    </div>
                    <button 
                        type="button" 
                        className="btn btn-outline-primary btn-sm"
                        onClick={testConnection}
                        disabled={isLoading}
                    >
                        <i className="bi bi-arrow-repeat me-1"></i>
                        Test Connection
                    </button>
                </div>
            </div>
        </div>
    </>);
}